import React from 'react'
import { DataGrid, GridRowsProp, GridColDef, GridOverlay, GridCellParams } from '@mui/x-data-grid';

export interface PbGridProps {
    rows: GridRowsProp,
    columns: GridColDef[],
    onLineClick: (e: GridCellParams<any, any, any>) => void
}

export default function PbGrid(props: PbGridProps) {
    return <>
        <div style={{ height: 'min(600px, 70vh)', width: '100%' }}>
            <DataGrid
                sx={{
                    bgcolor: 'background.paper',
                    borderColor: 'divider',
                    borderRadius: '14px',
                    boxShadow: 'var(--pb-shadow)',
                    '& .MuiDataGrid-columnHeaders': { bgcolor: 'var(--pb-bg)', borderTopLeftRadius: '14px', borderTopRightRadius: '14px' },
                    '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 600, color: 'primary.dark' },
                    '& .MuiDataGrid-row:hover': { bgcolor: 'var(--pb-accent-soft)' },
                    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                }}
                rows={props.rows}
                columns={props.columns!}
                hideFooterSelectedRowCount
                components={{
                    NoRowsOverlay: () => <>
                        <GridOverlay style={{
                            flexDirection: 'column'
                        }}>
                            <div>Sem dados a exibir</div>
                        </GridOverlay>
                    </>
                }}
                onCellClick={props.onLineClick}
            />
        </div>
    </>
}